import { CartScopeEq } from '@/models/cart/group/scope'
import { toQuery } from '@spa/components/pages/order/scope-transpiler'

export class OrderHistoryQueryBuilder {
  static empty(): OrderHistoryQueryBuilder {
    return new OrderHistoryQueryBuilder({})
  }

  private constructor(
    private readonly query: object
  ) {}

  withLimit(limit: number): OrderHistoryQueryBuilder {
    return new OrderHistoryQueryBuilder({
      ...this.query,
      limit,
    })
  }

  withMaybeCartScope(cartScope?: CartScopeEq): OrderHistoryQueryBuilder {
    return cartScope ? this.withCartScope(cartScope) : this
  }

  withCartScope(cartScope: CartScopeEq): OrderHistoryQueryBuilder {
    return new OrderHistoryQueryBuilder({
      ...this.query,
      aux_string_9: toQuery(cartScope),
    })
  }

  toObject(): object {
    return this.query
  }
}
